import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from "react";
import { Button, type ButtonVariant } from "./Button";

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible name and tooltip. Icon-only controls always need one. */
  label: string;
  icon: ReactNode;
  variant?: ButtonVariant;
}

/** Square 44px icon control with a required accessible name. Forwards its ref for drag handles. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, variant = "ghost", className = "", ...rest },
  ref,
) {
  return (
    <Button
      ref={ref}
      variant={variant}
      aria-label={label}
      title={label}
      className={`size-11 shrink-0 px-0 ${className}`}
      {...rest}
    >
      {icon}
    </Button>
  );
});
